import { Component, OnInit, OnDestroy } from '@angular/core';
import { TraductorService } from '../../servicios/traductor.service';
import { InfoC } from '../../Models/info';
import { Subscription } from 'rxjs';


// esta linea siemprea va a dar error.
// los Archivos tipo JSON siempre se guardan el la carpeta Assets;
import * as Info from '../../../assets/JsonEstructura/info.json';


declare var $: any;
//Json Español
const dataE = JSON.stringify(Info);
const data = JSON.parse(dataE);
//Json Ingles




@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']

})
export class HomeComponent implements OnInit {

  public suscription: Subscription;

  public data: any = data;
  public data2: any;
  public infoC: InfoC;
  public idioma: string = "";

  constructor(
    private _traductorService: TraductorService
  ) {
    //Guarda el idioma en el localstorage
    this.idioma = localStorage.getItem("idioma");
    //Crea el array para asignar los textos

    this.data2 = new Array(data);

    this.suscription = this._traductorService.getEvento().subscribe(
      {
        next: (result) => {
          if (result) {
            if (result == 2) {
              this.idioma = "2";
              localStorage.setItem("idioma", this.idioma);
            } else if (result == 3) {
              this.idioma = "3";
              localStorage.setItem("idioma", this.idioma);
            }else if (result == 4) {
              this.idioma = "4";
              localStorage.setItem("idioma", this.idioma);
            }else if (result == 5) {
              this.idioma = "5";
              localStorage.setItem("idioma", this.idioma);
            }else if (result == 6) {
              this.idioma = "6";
              localStorage.setItem("idioma", this.idioma);
            }else if (result == 7) {
              this.idioma = "7";
              localStorage.setItem("idioma", this.idioma);       
            }else if (result == 8) {
              this.idioma = "8";
              localStorage.setItem("idioma", this.idioma);       
            }

          }
        },
        error: (error) => {
          console.log(error)
        }
      }
    )

  }

  ngOnInit() {

    $('.carousel').carousel({
      interval: 3000,
      keyboard: true,
      touch: true,
      ride: true
    });
    $('#myCollapsible').collapse({
      toggle: true
    });

  }

  ngOnDestroy(): void {
    this.suscription.unsubscribe();
  }



}
